module.exports = __webpack_public_path__ + "img/upper-right.dd557f9c.svg";